module.exports = __webpack_public_path__ + "static/media/LOGO-UNICOAGRO.b5208ca2.png";